import { Routes } from "@angular/router";

export const RECRUITERS_ROUTES: Routes = [
    {
        path: 'recruiters',
        title: 'Recruiters',
        loadComponent: () => import('./recruiters.component').then((e) => e.RecruitersComponent),
        data: {
            icon: 'people',
            module: 'RECRUITER_MANAGEMENT',
        },
        children: [
            {
                path: ':id',
                title: 'Recruiter jobs',
                loadComponent: () => import('./recruiter-jobs/recruiter-jobs.component').then((m) => m.RecruiterJobsComponent),
            },
            {
                path: '',
                pathMatch: 'full',
                data: {
                    reuse: true,
                },
                loadComponent: () => import('./recruiter-list/recruiter-list.component').then((m) => m.RecruiterListComponent),
            },
        ]
    }
]
